/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2018, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
// This file is used to create the require layers. Only the entry points are necessary
define([
	'./6',	//6:
	'./7',	//7:
	'./8',	//8:
	'./9',	//9:
	'./wa_infographic', //1000:
	'./ca_updateSheet1InUploadedFile', //1002:
	'./waca_removeWidgetContentBoardSpec', //1003:
	'./waca',	//1004:
	'./waca_shaping', //1005:
	'./VIDA_breakingchanges', //1006:
	'./multiLayersSupport', //1007:
	'./R9toR10', // 1008:
	'./dateTimeLocalFilter', //1009:
	'./HeliosToEndorUpgrade', //1010:
	'./LayoutPageSizeUpgrade', //1011:
	'./LayoutPositioningUpgrade', //1012:
	'./VIDAPropUpgrade', //1013:
	'./DataItemIdUpgrade', //1014:
	'./DataItemUpgrade', //1015:
	'./CompositeChartUpgrade', //1016:
	'./FredIsRedUpgrade', //1017:
	'./DataItemAggregationTypeUpgrade', //1018:
	'./VIDA_ClippingUpgrade', //1019:
	'./VIDA_OptimizeSizeUpgrade',//1020:
	'./VIDA_LabelsColorPropUpgrade', //1021:
	'./TextWidgetResponsiveUpgradeHelper', //1022:
	'./LayoutTemplateIndicatorUpgrade', //1023:
	'./RecommendedDriversUpgrade', //1024:
	'./DataItemAggregationTypeUpgradeForScatterAndBubble', //1025:
	'./TextWidgetParagraphUpgrade', //1026:
	'./RankSlotUpgrade', //1027:
	'./VIDAPaddingPropUpgrade', //1300:
	'./DuplicateLayoutCssPropUpgrade', //1301:
	'./VIDALegendFontSizeMappingUpgrade', //1400:
	'./SummaryKPIUpgrade', //1401
	'./WidgetTitleAriaLabelUpgrade', //1402
	'./MissingOriginalCustomGroupItemId', //1403
	'./DrillthroughDefinitionScopeUpgrade', //1404
	'./TabIconUpgrade', //1600
	'./CssAndFillColorConflictUpgrade', //1601
	'./NewGenSpec', //1800
	'./ColBarZeroOriginValueUpgrade', //1801
	'./DatasetScopeMultiMeasure', //1802
	'./CompositeChartV2Upgrade', //1803
	'./CarbonPlexUpgrade', //1804
	'./KPI_VCF_Upgrade', //1805
	'./AggregateTypeVisibleUpgrade', //1806
	'./CrosstabTable_VCF_Upgrade', //1807
	'./FredIsRedColorMapUpgrade', //1808

	// Start of CA 11.2.0
	'./ContrastLabelUpgrade', //2001
	'./DrillthroughDefinitionEventGroupIdUpgrade', //2002
	'./VIDARelativePaddingPropUpgrade', //2003
	'./MoveOriginalCustomGroupItemId', //2004
	'./VIDADefaultNullValuesUpgrade', //2005
	'./ShowFooterUpgrade' //2006
], function() {
	return {
		upgraders: arguments
	};
});
